import React, {Component} from 'react';
import topBar from '../modules/topBar';
import navbar from '../modules/navbar';
import folder from '../modules/folder';

class FolderPageComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  render() {
  	return (
	    <div id="page-folder">
        <topBar.container/>
        <div className="bottom-container">
          <navbar.container/>
          <div className="main-section">
            <folder.container />
          </div>
        </div>
	    </div>
	  )
  }
}

export default FolderPageComponent;
